import { Routes } from '@angular/router';
import { authGuard } from './core/auth/guards/auth.guard';
import { adminGuard } from './core/auth/guards/admin.guard';
import { workbenchGuard } from './core/auth/guards/workbench.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'workbench',
    pathMatch: 'full'
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./core/auth/components/sign-in/sign-in.component').then(m => m.SignInComponent)
  },
  {
    path: 'oauth/callback',
    loadComponent: () => import('./core/auth/components/callback/callback.component').then(m => m.CallbackComponent)
  },
  {
    path: 'sign-out',
    loadComponent: () => import('./core/auth/components/sign-out/sign-out.component').then(m => m.SignOutComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/admin-layout/admin-layout').then(m => m.AdminLayoutComponent),
    children: [
      {
        path: 'workbench',
        canActivate: [workbenchGuard],
        loadChildren: () => import('./features/core-batch/core-batch.routes').then(m => m.WORKBENCH_ROUTES),
      },
      {
        path: 'splitter',
        loadComponent: () => import('./features/splitter/pages/splitter/splitter').then(m => m.SplitterComponent)
      },

      {
        path: 'admin',
        canActivate: [adminGuard],
        children: [
          {
            path: '',
            redirectTo: 'prompts',
            pathMatch: 'full'
          },
          {
            path: 'analytics',
            loadComponent: () => import('./features/analytics/components/analytics-dashboard/analytics-dashboard').then(m => m.AnalyticsDashboardComponent)
          },
          {
            path: 'prompts',
            loadComponent: () => import('./features/prompts/components/prompt-list/prompt-list').then(m => m.PromptListComponent)
          },
          {
            path: 'prompts/create',
            loadComponent: () => import('./features/prompts/pages/prompt-details/prompt-details').then(m => m.PromptDetailsComponent)
          },
          {
            path: 'prompts/create/prompt-builder',
            loadComponent: () => import('./features/prompts/pages/prompt-builder/prompt-builder').then(m => m.PromptBuilderComponent)
          },
          {
            path: 'prompts/create/review',
            loadComponent: () => import('./features/prompts/pages/prompt-review/prompt-review').then(m => m.PromptReviewComponent)
          },
          {
            path: 'prompts/:id/edit',
            loadComponent: () => import('./features/prompts/pages/prompt-details/prompt-details').then(m => m.PromptDetailsComponent)
          },
          {
            path: 'prompts/:id/edit/prompt-builder',
            loadComponent: () => import('./features/prompts/pages/prompt-builder/prompt-builder').then(m => m.PromptBuilderComponent)
          },
          {
            path: 'prompts/:id/edit/review',
            loadComponent: () => import('./features/prompts/pages/prompt-review/prompt-review').then(m => m.PromptReviewComponent)
          }
        ]
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./shared/components/not-found/not-found').then(m => m.NotFoundComponent)
  }
];
